module.exports = __webpack_public_path__ + "img/nemean.5e552d01.png";